import { MouseEvent, useEffect, useRef, useState } from "react";

import { Avatar } from "primereact/avatar";
import { PrimeIcons } from "primereact/api";
import { Menu } from "primereact/menu";
import { labelLogout, labelProfilo } from "_constants";
import { useAppSelector } from "store/store";
import { useConfirmDialogExit } from "hooks";

export const ToolbarEndContent = () => {
  const profile = useAppSelector((state) => state.profiloSlice);
  const menuRight = useRef(null);
  const { showLogoutConfirmDialogExit } = useConfirmDialogExit();
  const [showContent, setShowContent] = useState(true);

  const items = [
    {
      label: labelProfilo,
      icon: PrimeIcons.USER,
      template: (
        <div className="flex-container gap-8 padd-7 menu-item-border-bottom">
          <Avatar
            label={`${profile.firstName
              .charAt(0)
              .toUpperCase()}${profile.lastName.charAt(0).toUpperCase()}`}
            size="large"
            shape="square"
          />
          <div className="flex-container column gap-2 justify-center profile-info">
            <span className="text-base-bold capitalize clamp-1 break-word">
              {profile.firstName} {profile.lastName} {profile.role}
            </span>
            <span className="text-base-regular text-capitalize">{profile.role}</span>
          </div>
        </div>
      ),
      command: () => {},
    },
    {
      label: labelLogout,
      icon: PrimeIcons.SIGN_OUT,
      className: "p-menu-item-custom",
      command: () => {
        showLogoutConfirmDialogExit();
      },
    },
  ];

  const toggleMenu = (e: MouseEvent) => {
    if (menuRight !== null && menuRight !== undefined) {
      (menuRight!.current! as any).toggle(e);
    }
  };

  useEffect(() => {
    setShowContent(profile?.role?.length > 0);
  }, [profile]);

  return showContent ? (
    <>
      <Menu
        model={items}
        popup
        ref={menuRight}
        id="popup_menu_right"
        className="p-menu-custom-logout"
        popupAlignment="right"
      />

      <Avatar
        label={`${profile.firstName.charAt(0).toUpperCase()}${profile.lastName
          .charAt(0)
          .toUpperCase()}`}
        size="normal"
        shape="square"
        onClick={toggleMenu}
        aria-controls="popup_menu_right"
        aria-haspopup
      />
    </>
  ) : null;
};
